import { useEffect, Fragment } from 'react'
import {useParams} from 'react-router-dom'
import Lottie from 'react-lottie';
import animationData from './plane.json'
import { LaptopWindows } from '@material-ui/icons';

const ExternalCallback = ({ returnUrl, ...props }: any) => {
  const { provider } = useParams<Record<string, string | undefined>>();

  const defaultOptions = {
    loop: true,
    autoplay: true, 
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  useEffect(() => {
    let urlBase: string = 
    `/api/authenticateExternal/ExternalLogin/${provider}/?ReturnUrl=${encodeURIComponent(returnUrl)}`;
    (async () => { 
      if (provider?.endsWith('callback')) {
        urlBase = urlBase.replace('callback', '')
        const llamada3 = await fetch(urlBase,
          {
            method: "POST",
            headers: {
            },
            credentials: "include",
          }
        );
        const data = await llamada3.json();
        if (data.isOk) {
          window.location.href = data.redirectUrl;
        }
        else {
          window.location.href = urlBase
        }
      } else {
        window.location.href = urlBase;
      }
      
    })();
  }, [provider, returnUrl]);

  return (
    <Fragment>
      <Lottie
        options={defaultOptions}
        height={"55vh"}
        width={"45vh"}
        isStopped={false}
        isPaused={false}
        speed={3}
      />
    </Fragment>
  );
}

export default ExternalCallback;